import { createZodDto } from "nestjs-zod/dto";
import { z } from "nestjs-zod/z";

export const InterviewTypeEnum = z.enum(["BEHAVIORAL", "TECHNICAL", "MIXED"]);

export const CreateInterviewSchema = z.object({
  resumeId: z.string().cuid().optional(),
  jobDescription: z.string().min(10).max(10000),
  jobTitle: z.string().min(1).max(200).optional(),
  companyName: z.string().min(1).max(200).optional(),
  interviewType: InterviewTypeEnum.default("MIXED"),
  questionCount: z.number().int().min(4).max(12).default(8),
});

export class CreateInterviewDto extends createZodDto(CreateInterviewSchema) {}
